import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 64px;
    `,

    "TitleDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["large-semibold"]};
            width: 100%;
            padding-bottom: 16px;
            margin-bottom: 8px;
            border-bottom: 1px solid ${({ theme }) => theme.color["black"]};
        }
    `,
    "InfoDiv": styled.div`
        display: flex;
        justify-content: space-between;

        & > h2 {
            ${({ theme }) => theme.font["large-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }

        & > p {
            ${({ theme }) => theme.font["large-medium"]};
        }
    `,

    "ContentDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["xxlarge-medium"]};
            color: ${({ theme }) => theme.color["red"]};
        }
        
        & > p {
            ${({ theme }) => theme.font["large-medium"]};
        }
    `,
}